'use strict';

/* App Module */

angular.module('accessWebClient', [
    'ngAnimate',
    'ngSanitize',
    'access.Resource',
    'accessApiService',
    'access.Config',
    'access.Nodes',
    'access.Account',
    'access.Utils',
    'access.Navigation',
    'access.FileSystem',
    'access.DataTable',
    'access.FlashMessages',
    'access.OfficeOnline',
    'access.Modal',
    'access.Security',
    'access.ReturnPage',
    'perfect_scrollbar'
]);
